import Ember from 'ember';
import Bugsnag from '@bugsnag/js';
import ENV from 'donor-elf-web/config/environment';

export default {
  name: 'bugsnag',
  initialize: function (/*application*/) {
    if (!ENV.bugsnag?.apiKey) {
      return;
    }

    Bugsnag.start({
      apiKey: ENV.bugsnag.apiKey,
      appVersion: ENV.appVersion,
    });

    const oldOnError = Ember.onerror;

    Ember.onerror = function (error) {
      Bugsnag.notify(error);
      oldOnError?.(error);
    };
  },
};
